import {get, post } from './http'
// 系统配置
// 基础配置
export const newspam_get = p => get('/api/adm/cgi/newspam.cgi', p);
export const newspam1_get = p => get('/api/adm/cgi/newspam.cgi', p);
export const newspam_post = p => post('/api/adm/cgi/newspam.cgi', p);

//系统管理  ji角色列表
export const admentrole_get = p => get('/api/adm/cgi/admentrole.cgi', p);
export const admentrole_post = p => post('/api/adm/cgi/admentrole.cgi', p);